'use client';

import { FC, useMemo } from 'react';
import { FATCATranslations } from '../../../utils/getFATCATranslations';
import { useFATCAFormState } from '../../../utils/useFATCAFormState';
import { css } from '@bts-web/utils-style-engine';
import { ButtonBase } from '../../../../common';
import { useClientTranslation } from '@bts-web/utils-lokalise';
import { FATCACheckboxEntry } from '../../reusable/FATCACheckboxEntry/FATCACheckboxEntry';

const FATCATinMissingReasonPage: FC<{
  fatcaFormState: ReturnType<typeof useFATCAFormState>;
  translations: FATCATranslations;
}> = ({ fatcaFormState, translations }) => {
  const { t } = useClientTranslation();

  const { fatcaTaxResidencies, onNextStep } = fatcaFormState;

  const { fatcaTaxResidencies: fatcaTaxResidencyEntries } = fatcaTaxResidencies;

  const { buttonDisabled, residencyEntriesWithoutTIN } = useMemo(() => {
    const residencyEntriesWithoutTIN = fatcaTaxResidencyEntries.filter(
      (entry) => entry.tinAbsent,
    );

    const buttonDisabled = residencyEntriesWithoutTIN.every(
      (item) =>
        !('tinAbsentSelectedReason' in item) || !item.tinAbsentSelectedReason,
    );

    return { residencyEntriesWithoutTIN, buttonDisabled };
  }, [fatcaTaxResidencyEntries]);

  return (
    <div
      className={css({
        display: 'flex',
        flexDirection: 'column',
        gap: 'small',
      })}
    >
      {residencyEntriesWithoutTIN.map((entry) => {
        return (
          <section key={entry.id}>
            <h6 className={css({ mb: 'small' })}>
              {t(
                'fatca_missing_tin_text_answer_ask' as 'missing_translation_key',
                {
                  country: entry.countryValue,
                },
              )}
            </h6>
            <ul
              className={css({
                display: 'flex',
                flexDirection: 'column',
                gap: 'small',
                padding: '0',
                listStyleType: 'none',
              })}
            >
              {'reasonList' in entry &&
                Array.isArray(entry.reasonList) &&
                entry.reasonList.map((reason) => {
                  return (
                    <li key={reason.value}>
                      <FATCACheckboxEntry
                        label={reason.label}
                        name={`tinAbsentSelectedReason-${entry.id}`}
                        checked={entry.tinAbsentSelectedReason === reason.value}
                        onChange={() =>
                          fatcaTaxResidencies.updateFATCATaxResidency(
                            entry.id,
                            {
                              ...entry,
                              tinAbsentSelectedReason: reason.value,
                            },
                          )
                        }
                      />
                    </li>
                  );
                })}
            </ul>
          </section>
        );
      })}

      <ButtonBase
        visual="primary"
        size="large"
        onClick={onNextStep}
        disabled={buttonDisabled}
        fullWidth
      >
        {translations.next}
      </ButtonBase>
    </div>
  );
};

export { FATCATinMissingReasonPage };
